import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./style.css";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <div className="notfound-code-box">
          <span className="notfound-code">404</span>
        </div>
        <h1 className="notfound-title">Page Not Found</h1>
        <p className="notfound-message">
          The page you're looking for doesn't exist or has been moved.
          Let's get you back on track.
        </p>
        <div className="notfound-actions">
          <a href="/" className="notfound-btn notfound-btn-primary">
            <span role="img" aria-label="home">🏠</span>
            Go Home
          </a>
          <button
            className="notfound-btn notfound-btn-secondary"
            onClick={() => window.history.back()}
          >
            <span role="img" aria-label="back">⬅️</span>
            Go Back
          </button>
        </div>
        <div className="notfound-links-section">
          <p className="notfound-links-title">
            Looking for something specific?
          </p>
          <div className="notfound-links">
            <a href="/games" className="notfound-link games">Games</a>
            <span className="notfound-link-sep">•</span>
            <a href="/movies" className="notfound-link movies">Movies</a>
            <span className="notfound-link-sep">•</span>
            <a href="/tv-shows" className="notfound-link tv">TV Shows</a>
            <span className="notfound-link-sep">•</span>
            <a href="/blog" className="notfound-link blog">Blog</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;